import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDeviationMatureFilter } from '../../../utils/hooks/useDeviationMatureFilter';
import { BlockReasons } from '../../../Moderation/redux/types';
import s from './MatureIndicator.scss';
const MatureIndicator = ({ deviation , className  })=>{
    const { displayReason  } = useDeviationMatureFilter(deviation);
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("span", null, displayReason === BlockReasons.Nsfg ? t('deviation.details.nsfg') : t('deviation.details.mature')));
};
MatureIndicator.displayName = 'MatureIndicator';
export default MatureIndicator;
